import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const InputWrap = ({ children, column }) => {
  const useStyles = makeStyles({
    inputWrap: {
      display: 'grid',
      gridTemplateColumns: column ? 'auto' : '1fr 1fr',
      gap: '22px 44px',

      '@media screen and (max-width: 959px)': {
        gridTemplateColumns: 'auto',
      },
    },
  });
  const classes = useStyles();

  return (
    <Box className={classes.inputWrap}>
      {children}
    </Box>
  );
};

InputWrap.defaultProps = {
  children: <></>,
  column: false,
};

InputWrap.propTypes = {
  children: PropTypes.element,
  column: PropTypes.bool,
};

export default InputWrap;
